import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Floating navigation bar for PWA standalone mode.
 * Only renders when the app is running as an installed PWA (no browser chrome).
 */
const PWANavBar: React.FC = () => {
  const navigate = useNavigate();
  const [isStandalone, setIsStandalone] = React.useState(false);

  React.useEffect(() => {
    const mq = window.matchMedia('(display-mode: standalone)');
    const iosStandalone = (navigator as any).standalone === true;
    setIsStandalone(mq.matches || iosStandalone);

    const handler = (e: MediaQueryListEvent) => setIsStandalone(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  if (!isStandalone) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-full shadow-lg px-2 py-1.5">
      <button
        onClick={() => window.history.back()}
        className="p-2 rounded-full hover:bg-gray-100 active:bg-gray-200 transition"
        aria-label="Go back"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        onClick={() => navigate('/dashboard')}
        className="p-2 rounded-full hover:bg-gray-100 active:bg-gray-200 transition"
        aria-label="Home"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1h-2z" />
        </svg>
      </button>
      <button
        onClick={() => window.history.forward()}
        className="p-2 rounded-full hover:bg-gray-100 active:bg-gray-200 transition"
        aria-label="Go forward"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default PWANavBar;
